import React from 'react';

import HeaderContainer from 'containers/header';
import FooterContainer from 'containers/footer';
import InsufficientPoints from 'containers/shopping-cart/insufficient-points';

const ShoppingCartInsufficientPoints = () => {
  return (
    <div>
      <HeaderContainer />
      <InsufficientPoints />
      <FooterContainer />
    </div>
  );
};

export default ShoppingCartInsufficientPoints;
